// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24yed","footer":"styles_footer__3qfWv"};